import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import 'intl-pluralrules';
import en from './locales/en.json';

// Some Jest mocks replace react-i18next without exporting the plugin.
// Skipping .use(undefined) lets the catalog still load for error copy.
if (initReactI18next) {
  i18n.use(initReactI18next);
}
i18n.init({
  resources: {
    en: { translation: en },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React already escapes values
  },
});

export default i18n;
